import { useCallback, useEffect, useRef, useState } from "react"
import { AssistancePlanContextScreen } from "../../screen/AssistancePlanContextScreen"
import Send from "../../core/communication"
import { getFormsSteps, groupFormStepsByName } from "../../core/utils/farmProfile"
import { customToast } from "../../components/Toast"
import { useSearchParams, useLocation, useNavigate, useParams } from "react-router-dom"
import { useAssistancePlanContext } from "../../core/context/assistancePlanContext"
import { useChatContext } from "../../core/context/chatContext"
import { useFarmerProfile } from "../../core/context/farmerProfileContext"
import { blobToBase64, sendFileToFirebase } from "../../core/utils/hooks/uploadItem"
import moment from "moment"
import { useScope } from "../SelectProjectCompanyContainer"
import { debounce } from "lodash"
import { isMobile } from "react-device-detect"
import { useForm } from "react-hook-form"
import { useSelector } from "react-redux"

var options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
}


export const filterValidUuidKeys = (obj) => {
  const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}(-messages|-evidence)?$/i

  return Object.keys(obj)
    .filter(key => regex.test(key))
    .reduce((acc, key) => {
      acc[key] = obj[key]
      return acc
    }, {})
}

export const AssistancePlanContextContainer = ({
  onlyForm = true,
  handleOpenLinkMessage,
  farmerDetails,
  resetFarmerProfile,
  defaultAnswers,
  setDefaultAnswers,
  formQuestionMessage
}) => {
  const navigate = useNavigate()
  const { userId, projectId } = useParams()
  const { search, state } = useLocation()
  const { scope } = useScope()

  const [_, setSearchParams] = useSearchParams()
  const { pinnedMessages, resetPinnedMessages, fixedMessage, setFixedMessage, setEvidenceId, removePinnedMessage: removePinnedMessageContext } = useChatContext()
  const { hideMainCard, setPageName } = useFarmerProfile()
  const {
    handleChangeAnswer,
    resetAnswers,
    answers,
    convertDefaultAnswers,
    handleChangeMessage,
    setDataToUpdate,
    dataToUpdate,
    handleChangeDataToUpload,
    handleChangeSelectedProject,
    selectedProject,
    handleChangeAssistanceTitle,
    assistanceTitle,
    assistanceLoadingTitle,
    setAssistanceLoadingTitle,
    savedStepsToRespond,
    setSavedStepsToRespond,
    resetAssistancePlanContext,
    handleRemoveEvidence
  } = useAssistancePlanContext()

  const isUserAdmin = useSelector((state) => state.app?.isUserAdmin)
  const user = useSelector((state) => state.app?.user?.user)
  const farmerDetailsCached = useSelector((state) => state.app?.cacheFarmerState)
  const cachedProjectId = useSelector((state) => state?.app?.cachedProjectId)
  const isUserManager = user?.roles?.role === "USER_MANAGER"
  const [technicalList, setTechnicalList] = useState([])
  const [formStepsGrouped, setFormStepsGrouped] = useState({})
  const [indicatorTabsOptions, setIndicatorTabsOptions] = useState([])
  const [formSteps, setFormSteps] = useState([])
  const [checkedSteps, setCheckedSteps] = useState({})
  const [stepsToRespond, setStepsToRespond] = useState([])
  const [modalAddFormIsOpen, setModalAddFormIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const [modalReturnIsOpen, setModalReturnIsOpen] = useState(false)
  const [sendEvaluationMessage, setSendEvaluationMessage] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)

  const [assistanceId, setAssistanceId] = useState(false)
  const [assistanceCategory, setAssistanceCategory] = useState(null)
  const [assistanceDate, setAssistanceDate] = useState(null)
  const [hasAllAnswers, setHasAllAnswers] = useState(false)
  const [contextData, setContextData] = useState([])
  const [contextDetails, setContextDetails] = useState({})
  const [evaluationModal, setEvaluationModal] = useState(false)
  const [formId, setFormId] = useState(null)
  const [loadingProcessImage, setLoadingProcessImage] = useState(false)
  const [loadingSendEvaluation, setLoadingSendEvaluation] = useState(false)
  const [loadingSteps, setLoadingSteps] = useState(false)
  const [loadingTechnical, setLoadingTechnical] = useState(false)
  const [uploadedFiles, setUploadFile] = useState(false)
  const [uploaded, setUploaded] = useState(null)
  const [scheduleReturn, setScheduleReturn] = useState(false)
  const [scheduleReturnValues, setScheduleReturnValues] = useState({})
  const [evaluationValue, setEvaluationValue] = useState(null)
  const [geolocation, setGeolocation] = useState("")
  const [assistanceTitleEdit, setAssistanceTitleEdit] = useState(false)

  const { register, setValue, getValues, formState, watch } = useForm({
    defaultValues: {
      title: "",
    },
  })

  const fromChat = state?.fromChat || {}
  const frominitial = state?.frominitial || {}
  const fromUsers = state?.fromUsers || {}

  const removeEvaluationStep =
    contextDetails?.responsible === user?.id || assistanceId === "false" || search?.includes("new")

  let projectOptions = null

  const getProjectOptions = () => {
    if (farmerDetails?.projectIds?.length) {
      return farmerDetails.projectIds.map((value, index) => ({
        value,
        label: farmerDetails.projectNames?.[index] ?? "",
      }))
    } else {
      const source = farmerDetailsCached?.fromUsers || farmerDetailsCached?.fromChat
      if (source) {
        return [
          {
            value: source?.projectId,
            label: source?.project || source?.projectId,
          },
        ]
      } else if (fromUsers?.projectsByUser?.length > 0) {
        return fromUsers.projectsByUser
      }
      else if (frominitial?.projectsByUser?.length > 0) {
        return frominitial.projectsByUser
      }
    }
    return []
  }

  projectOptions = getProjectOptions()

  const handleProjectSelection = (project) => {
    if (project) {
      handleChangeSelectedProject(project)
    }
  }

  useEffect(() => {
    const isValidSearch =
      search.includes("open") || search.includes("schedule") || search?.includes("closed")
    const isForm =
      search.includes("context=false") && search.includes("form") && search.includes("steps") && !search.includes("new")
    const isProjectIdAvailable = contextDetails?.projectId

    if (isValidSearch && isProjectIdAvailable) {
      const selectedProject = projectOptions.find(
        (project) => project.value === contextDetails?.projectId,
      )
      handleProjectSelection(selectedProject)
    } else if (isForm && cachedProjectId) {
      handleProjectSelection({ value: cachedProjectId, label: cachedProjectId })
    } else if (projectOptions.length === 1) {
      handleProjectSelection(projectOptions[0])
    } else if (!projectOptions?.length || !scope?.id) {
      return
    }
  }, [JSON.stringify(projectOptions), scope?.id, cachedProjectId])

  const farmerOptions =
    selectedProject && Object.keys(selectedProject)?.length > 0
      ? { ...farmerDetails, projectId: selectedProject?.value }
      : { ...farmerDetails, projectId: selectedProject?.value || projectId || search?.split("projectId=")[1]?.split("&")[0] }

  function success(pos, answer) {
    const { latitude, longitude } = pos.coords
    if (answer) {
      handleChange(answer.type, `${latitude}|${longitude}`, answer.name)
    } else {
      setGeolocation(`${latitude}|${longitude}`)
    }
  }

  function errors(err) {
    console.log(`ERROR(${err.code}): ${err.message}`)
    if (isMobile) {
      customToast(
        "Para inserir sua localização automaticamente, ative as permissões de localização nas configurações do navegador do seu celular.",
        "error",
      )
    }
  }

  const getUserLocation = async (answer = null) => {
    const hasGeolocationQuestion = formSteps.some(
      (step) =>
        Array.isArray(step.fields) && step.fields.some((item) => item?.type === "geolocation"),
    )

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => success(pos, answer),
        (err) => {
          if (isMobile && hasGeolocationQuestion) {
            customToast(
              "Para inserir sua localização automaticamente, ative as permissões de localização nas configurações do navegador do seu celular.",
              "error"
            )
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      )
    } else {
      customToast(
        "Geolocalização não é suportada neste navegador.",
        "error"
      )
    }
  }

  useEffect(() => {
    if (geolocation !== "") {
      getUserLocation()
    }
  }, [geolocation])

  useEffect(() => {
    if (stepsToRespond && stepsToRespond.length > 0 && geolocation !== "") {
      for (let indexSteps = 0; indexSteps < stepsToRespond.length; indexSteps++) {
        const step = stepsToRespond[indexSteps]
        if (step?.questions?.length > 0) {
          for (let indexQuestions = 0; indexQuestions < step.questions.length; indexQuestions++) {
            const question = step.questions[indexQuestions]
            if (question?.type === "geolocation") {
              handleChange(question.type, geolocation, question.name)
            }
          }
        }
      }
    }
  }, [stepsToRespond, geolocation])

  const loadAllTec = async () => {
    try {
      setLoadingTechnical(true)
      const projectId = selectedProject?.value || scope?.id || contextProject
      const response = await Send.get(`/users/tec-or-manager/${projectId}`, "scopeType=project")

      setTechnicalList(response.map((row) => ({ value: row?.id, label: row?.name })))
    } catch (error) {
      console.log("Error => ", error)
      customToast("Erro ao carregar técnicos", "error")
    }
    finally {
      setLoadingTechnical(false)
    }
  }

  const loadForms = async () => {
    const linkedAssistanceId = assistanceId ? `linkedAssistance=${assistanceId}` : ``
    const currentProject = selectedProject?.value || farmerDetails?.projectId || scope?.id

    if (
      (formId && !search.includes("steps")) ||
      (search.includes("new") && !selectedProject?.value)
    ) {
      return
    }

    try {
      setLoadingSteps(true)
      const response = await Send.get(
        `/forms/form-wizard/project/${currentProject}/form/${formId || "fdd3a40d-7a5a-409f-81e2-1a94c4e3a039"
        }`,
        linkedAssistanceId,
      )

      setPageName(response?.data?.title || "Atendimento")

      setFormStepsGrouped(groupFormStepsByName(response?.screens))
      setIndicatorTabsOptions(getFormsSteps(response.screens))
      setLoadingSteps(false)
    } catch (error) {
      console.log("Error -> ", error)
    }
  }

  const getStepsToRespondQuery = (stepIds) => {
    let newStepsToRespond = stepIds.split("%2C")
    let allGroups = []
    let allStepKeys = Object.keys(formStepsGrouped)

    allStepKeys.forEach((step) => {
      allGroups = [...allGroups, ...formStepsGrouped[step][0]?.groups]
    })

    newStepsToRespond = newStepsToRespond
      .map((item) => {
        let group = allGroups.find((row) => row?.id === item)
        return group ? { ...group, questions: group?.questions || [] } : null
      })
      .filter((row) => row)

    setStepsToRespond(newStepsToRespond)
    setSavedStepsToRespond(newStepsToRespond)
  }

  const getStepsByDefaultQuestions = () => {
    const onlyDefaultFormQuestionIds = defaultAnswers.map((row) => row.formQuestionId)
    let allGroups = []
    let allStepKeys = Object.keys(formStepsGrouped)
    let stepsByAnswers = []

    allStepKeys.map((step) => {
      allGroups = [...allGroups, ...formStepsGrouped[step][0]?.groups]
    })

    allGroups.map((group) => {
      const hasQuestion = group.questions.find((row) =>
        onlyDefaultFormQuestionIds.includes(row?.name),
      )

      if (hasQuestion) {
        stepsByAnswers.push(group?.id)
      }
    })

    setSearchParams({
      context: assistanceId,
      form: formId || "",
      steps: stepsByAnswers.join(","),
      projectId: contextDetails?.projectId,
      category: assistanceCategory || "startedForms",
    })
  }

  useEffect(() => {
    if (assistanceId && formStepsGrouped && defaultAnswers.length) {
      getStepsByDefaultQuestions()
    }
  }, [formStepsGrouped, defaultAnswers])

  useEffect(() => {
    if (savedStepsToRespond?.length > 0) {
      setStepsToRespond(savedStepsToRespond)
    }
  }, [savedStepsToRespond])

  useEffect(() => {
    if (pinnedMessages && pinnedMessages.length && !fixedMessage.length) {
      setFixedMessage(pinnedMessages)
      resetPinnedMessages()
    }
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(search)
    const hasStepsParam = params.has("steps") && !!params.get("steps")
    const isStartedForm = formId && !hasStepsParam && search.includes("startedForms")

    let timeoutId

    if (isStartedForm || hasStepsParam) {
      setLoadingSteps(true)
    } else if (hasStepsParam) {
      timeoutId = setTimeout(() => {
        setLoadingSteps(false)
      }, 600)
    }

    return () => clearTimeout(timeoutId)
  }, [formId, search])

  useEffect(() => {
    if (search && search.split("?context=")[1]) {
      let context = search.split("?context=")[1]
      context = context?.split("&")[0]

      let category = search.split("&category=")[1]
      category = category?.split("&")[0]

      let formId = search.split("&form=")[1]
      formId = formId?.split("&")[0]

      if (formId) {
        setFormId(formId)
        hideMainCard(null, false)
      }

      if (search && search.split("steps=")[1]) {
        !savedStepsToRespond &&
          getStepsToRespondQuery(search.split("steps=")[1].split("&")[0], formId)
        //setLoadingSteps(false)
      } else if (context === "false") {
        //setModalAddFormIsOpen(true)
      }

      if (context && context !== "false") {
        setAssistanceId(context || true)
      }

      setAssistanceCategory(category)
    }

    return () => setAssistanceId(false)
  }, [search, savedStepsToRespond])

  useEffect(() => {
    if (selectedProject?.value || scope?.id) {
      loadAllTec();
    }
  }, [selectedProject?.value, scope?.id]);

  useEffect(() => setHasAllAnswers(false), [search])

  useEffect(() => {
    if (Object.keys(formStepsGrouped).length > 0) {
      if (search && search.split("steps=")[1]) {
        getStepsToRespondQuery(search.split("steps=")[1].split("&")[0])
        //setLoadingSteps(false)
      }
    }

    ; () => setStepsToRespond(null)
  }, [formStepsGrouped, search])

  useEffect(() => {
    const hasValidAssistanceId = assistanceId === true || (assistanceId && assistanceId?.content)
    const searchIncludesContext = search?.includes("context")
    const searchIncludesSteps = search?.includes("steps")
    const searchIncludesNewOrOpen =
      search?.includes("new") ||
      search?.includes("open") ||
      search.includes("schedule") ||
      search.includes("closed")
    const shouldLoadData =
      (searchIncludesContext && !searchIncludesSteps) ||
      (formId && searchIncludesSteps) ||
      search?.includes("projectId")

    if (hasValidAssistanceId) {
      setModalAddFormIsOpen(true)
    }

    if (shouldLoadData && (assistanceId || formId || searchIncludesNewOrOpen)) {
      loadForms()
      loadContext()
      if (!defaultAnswers.length) {
        loadAnswers()
      }
    }

    return () => {
      setModalAddFormIsOpen(false)
    }
  }, [assistanceId, search, formId, scope?.id, selectedProject?.value, farmerOptions?.projectId])

  useEffect(() => {
    if (search?.includes("new")) {
      setPageName("Registro de Atendimento")
    }
  }, [search])

  useEffect(() => {
    if (Object.keys(formStepsGrouped).length > 0 && indicatorTabsOptions.length > 0) {
      setFormSteps(formStepsGrouped[indicatorTabsOptions[0].label])
    }
  }, [formStepsGrouped, indicatorTabsOptions])

  const jsonFormat = (data) => {
    try {
      if (Array.isArray(data)) {
        return data
      }

      if (typeof data === "string") {
        let parsed = JSON.parse(data)

        if (typeof parsed === "string") {
          parsed = JSON.parse(parsed)
        }

        if (Array.isArray(parsed)) {
          return parsed
        }

        if (typeof parsed === "object" && parsed !== null) {
          return [parsed]
        }

        return [parsed]
      }
      if (typeof data === "object" && data !== null) {
        return [data]
      }
      return [data]
    } catch (error) {
      return []
    }
  }

  const loadContext = async () => {
    try {
      let response = await Send.get(`/events-sector/context/${assistanceId}`)

      if (response) {
        let context = (response?.context || []).map((row) => ({
          ...row,
          messageIds: jsonFormat(row?.messageIds),
        }))

        setContextData(context || [])
        setContextDetails(response?.esDetail || {})

        setGeolocation(response?.esDetail?.geoLocationCoordinates)

        if (response?.esDetail) {
          setDataToUpdate((curr) => ({
            ...curr,
            dateToAdd:
              dataToUpdate?.dateToAdd ||
              moment.utc(response.esDetail?.dateToAdd).format("YYYY-MM-DD"),
            technician: response.esDetail?.technician || dataToUpdate?.technician || user.id,
          }))
        }
        if (response?.esDetail?.start) {
          setAssistanceDate(moment.utc(response?.esDetail?.start).toDate())
        }
      }
    } catch (error) {
      console.log("Error -> ", error)
      customToast("Erro ao buscar contexto", "error")
    }
  }

  const loadAnswers = async () => {
    try {
      let response = await Send.get(`/events-sector/answers/${assistanceId}`)

      if (Array.isArray(response)) {
        response = response.map((row) => ({
          ...row,
          messageIds: jsonFormat(row?.messageIds),
          evidencesLinks: jsonFormat(row?.evidencesLinks),
        }))

        setDefaultAnswers(response)
        convertDefaultAnswers(response)
      }
    } catch (error) {
      console.log("Error -> ", error)
      customToast("Erro ao buscar respostas", "error")
    }
  }

  const handleActiveIndicator = (value) => {
    if (Array.isArray(value)) {
      setFormSteps(formStepsGrouped[value[0]?.label])
    } else {
      setFormSteps(formStepsGrouped[value?.label])
    }
  }

  const handleChangeChecked = (e) => {
    setCheckedSteps((curr) => ({
      ...curr,
      [e.target.name]: { value: !curr[e.target.name]?.value, step: formSteps[0]?.name },
    }))
  }

  const handleCloseFormModal = () => {
    setModalAddFormIsOpen(false)
    setCheckedSteps({})
    setStepsToRespond(null)
    //setSavedStepsToRespond(null)
  }

  const handleAddSteps = () => {
    let newStepsToRespond = Object.keys(checkedSteps).filter((step) => checkedSteps[step])

    if (!newStepsToRespond) {
      customToast("Não há grupos selecionados", "error")
      return
    }
    newStepsToRespond = newStepsToRespond
      .map((item) => {
        let group = formStepsGrouped[checkedSteps[item]?.step][0]?.groups.find(
          (row) => row.id === item,
        )

        return group ? { ...group, questions: group?.questions || [] } : null
      })
      .filter((row) => row)

    setSearchParams({
      context: assistanceId,
      form: formId || "",
      steps: newStepsToRespond.map((row) => row?.id).join(","),
      category: assistanceCategory || "startedForms",
      projectId: selectedProject?.value || farmerOptions?.projectId || contextDetails?.projectId,
      ...(search.includes("&origin=") && {
        origin: search.split("&origin=")[1],
      }),
    })
    setModalAddFormIsOpen(false)
  }

  const handleChange = (type, value, id) => {
    handleChangeAnswer(id, value, answers[`${id}-messages`] || [])
  }

  const handleOpenMessagesField = (question) => {
    if (!answers[question?.name]) {
      customToast("Você deve preencher a questão", "warning")
      return
    }

    setEvidenceId(question?.name)

    handleOpenLinkMessage(question)
  }

  const handleSendEvaluation = async (assistanceUserIds) => {
    try {
      setLoadingSendEvaluation(true)
      const response = await Send.post("/message/serviceEvaluation", { assistanceUserIds })

      customToast("Avaliação enviada com sucesso", "success")
    } catch (error) {
      console.log("Erro ao enviar avaliação", error)
      customToast("Erro ao enviar avaliação", "error")
    }
    setLoadingSendEvaluation(false)

    setEvaluationModal(false)
  }

  console.log("FARMER", contextData, contextDetails)

  const handleSave = async (assistanceType = "save", sendEvaluation = false) => {
    try {
      setLoading(true)

      delete dataToUpdate?.label

      let farmerDetails = {}

      if (!farmerOptions?.id || !farmerOptions?.projectId) {
        farmerDetails = {
          id: userId,
          projectId: selectedProject?.value || projectId || search?.split("projectId=")[1]?.split("&")[0],
        }
      } else {
        farmerDetails = farmerOptions
      }

      const filteredAnswers = filterValidUuidKeys(answers)

      const response = await Send.post(
        `/events-sector/${assistanceType === "save" ? "assistance-context" : "assistance-context-draft"
        }`,
        {
          assistanceId,
          assistanceDate: moment(assistanceDate).format("YYYY-MM-DD") || null,
          answers: filteredAnswers,
          assistanceType,
          farmerDetails,
          pinnedMessages: fixedMessage,
          formId,
          evaluationValue,
          scheduleReturn,
          scheduleReturnValues,
          dataToUpdate,
          title: getValues()?.title,
          geoLocationCoordinates: geolocation || null,
        },
      )

      if (response.status !== "success") {
        throw new Error(response)
      }

      if (
        assistanceType === "save" &&
        response["data"]?.assistanceUserId &&
        !formId &&
        sendEvaluation
      ) {
        await handleSendEvaluation([response["data"]?.assistanceUserId])
      }

      if (assistanceType === "draft") {
        customToast("Informações salvas.", "success")
        resetAnswers()
        resetFarmerProfile()
        navigate(`/farmer/profile/${userId}`)
        hideMainCard(false, true)
      }

      if (formId) {
        customToast("Formulário salvo.", "success")
        resetAnswers()
        resetFarmerProfile()
        navigate(`/farmer/profile/${userId}`)
        hideMainCard(false, true)
      } else {
        setScheduleReturn(false)
        goToNextStep()
      }
    } catch (error) {
      console.log("Error", error?.message)
      customToast("Erro ao salvar registro.", "error")
    }

    setStepsToRespond([])
    resetAssistancePlanContext()
    setLoading(false)
  }

  const handleUpdate = async (hasEvaluation, sendEvaluation = true) => {
    setLoading(true)

    delete dataToUpdate?.label

    const farmerDetails = {
      ...farmerOptions,
      projectId: contextDetails?.projectId,
    }

    const filteredAnswers = filterValidUuidKeys(answers)

    try {
      const response = await Send.put(`/events-sector/assistance-context`, {
        assistanceDate,
        assistanceId,
        answers: filteredAnswers,
        farmerDetails,
        formId,
        evaluationValue,
        scheduleReturn,
        scheduleReturnValues,
        dataToUpdate,
        title: getValues()?.title,
        geoLocationCoordinates: geolocation || null,
      })

      if (response.status !== "success") {
        throw new Error(response)
      }

      if (response["data"]?.assistanceUserId && !formId && sendEvaluation) {
        setValue("title", "")
        await handleSendEvaluation([response["data"]?.assistanceUserId])
      }

      if (formId) {
        customToast("Formulário atualizado.", "success")
        resetAnswers()
        resetFarmerProfile()
        navigate(`/farmer/profile/${userId}`)
        hideMainCard(false, true)
      } else {
        setScheduleReturn(false)
        goToNextStep()
      }

      setStepsToRespond([])
      resetAssistancePlanContext()
    } catch (error) {
      console.log("Error", error)
      customToast("Erro ao salvar registro.", "error")
    }

    setLoading(false)
  }

  const handleRemoveScheduledAssistance = async () => {
    try {
      const res = await Send.delete(`/events-sector/scheduled/${assistanceId}`)

      if (res.status === "Error") {
        customToast(res.message, "error")
      } else {
        customToast("Atendimento excluído com sucesso", "success")
        resetFarmerProfile()

        if (search && search?.includes("scheduleDetails")) {
          navigate(`/`)
        } else {
          navigate(`/farmer/profile/${userId}`)
        }
      }
    } catch (error) {
      console.error("Erro ao excluir atendimento:", error)
      customToast("Erro ao excluir atendimento", "error")
    }
  }

  const processFile = async (file) => {
    try {
      const base64 = await blobToBase64(file)
      return sendFileToFirebase(base64, file)
    } catch (error) {
      console.error("Erro ao processar arquivo:", error)
      throw error
    }
  }

  const onChangeFile = async (e, questionId, existingFiles = []) => {
    const chosenFiles = Array.from(e.target.files)

    if (e.target?.remove) {
      handleChangeAnswer(questionId, null, answers[`${questionId}-messages`] || [])
      return
    }

    try {
      setLoadingProcessImage(questionId)

      const processedFiles = await Promise.all(chosenFiles.map(processFile))

      const uniqueFiles = [...new Set(processedFiles), ...existingFiles]
      const formattedValue = uniqueFiles.join("|")
      setUploadFile(true)

      handleChangeAnswer(questionId, formattedValue, answers[`${questionId}-messages`] || [])

      customToast("Upload concluido com sucesso", "success")
    } catch (error) {
      customToast("Erro ao fazer upload dos arquivos", "error")
    } finally {
      setLoadingProcessImage("")
      setUploadFile(false)
      e.target.value = null
    }
  }

  const removeFile = () => { }

  const removePinnedMessage = (questionId, messageId) => {
    handleChangeMessage(questionId, messageId)
    removePinnedMessageContext(messageId, questionId)
  }

  const goToNextStep = () => {
    if (currentStep === 2 && !evaluationValue) {
      customToast("Preencha todas as informações!", "warning")
      return
    }
    setCurrentStep(currentStep + 1)
  }

  const goToPreviousStep = () => {
    if (removeEvaluationStep) {
      setCurrentStep(1)
    } else {
      setCurrentStep(currentStep - 1)
    }
  }

  const handleCloseReturnModal = () => {
    setModalReturnIsOpen(false)

    if (currentStep === 4 && search?.includes("fromUsers")) {
      navigate(`/users`)
      return
    }

    if (currentStep === 4) {
      resetAnswers()
      resetFarmerProfile()
      navigate(`/farmer/profile/${userId}`)
      hideMainCard(false, true)
    }

    setCurrentStep(1)
  }

  const handleChangeScheduleReturn = (name, value) => {
    setScheduleReturnValues((curr) => ({ ...curr, [name]: value }))
  }

  const handleConfirmReturn = (confirm) => {
    if (confirm && (!scheduleReturnValues["title"] || !scheduleReturnValues["dateToAdd"])) {
      customToast("Preencha todas as informações!", "warning")
      return
    }

    setScheduleReturn(confirm)

    if (removeEvaluationStep) {
      setCurrentStep(3)
    } else {
      goToNextStep()
    }
  }

  const handleChangeEvaluationValue = (newValue) => {
    setEvaluationValue(newValue)
  }

  const loadSuggestions = (value) => {
    return fetch("https://servicodados.ibge.gov.br/api/v1/localidades/municipios")
      .then((response) => response.json())
      .then((data) =>
        data
          .map((item) => {
            return {
              value: item.nome,
              label: item.nome,
            }
          })
          .filter((item) => item.label.toLowerCase().includes(value.toLowerCase())),
      )
  }

  const loadLocation = useCallback(
    debounce((value, callback) => {
      loadSuggestions(value).then((options) => callback(options))
    }, 1800),
    [],
  )

  const handleAssistanceTitleEdit = async (newTitle) => {
    try {
      console.log(contextDetails)
      await Send.put(`/events-sector/context/${assistanceId}/title`, { title: newTitle });

      handleChangeAssistanceTitle(newTitle);

      customToast('Título salvo com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao salvar título:', error);
      customToast('Erro ao salvar título.', 'error');
    }
  };

  useEffect(() => {
    if (contextDetails?.title || assistanceTitle) {
      const newTitle = contextDetails.title || assistanceTitle
      handleChangeAssistanceTitle(newTitle)
      setValue("title", newTitle)
    }
  }, [contextDetails, assistanceTitle])

  useEffect(() => {
    if (fromChat?.assistanceTitle || frominitial?.assistanceTitle || fromUsers?.assistanceTitle || assistanceTitle) {
      const newTitle = fromChat?.assistanceTitle || frominitial?.assistanceTitle || fromUsers?.assistanceTitle || assistanceTitle
      setAssistanceLoadingTitle(true)
      handleChangeAssistanceTitle(newTitle)
      setAssistanceLoadingTitle(false)
    }
  }, [state, assistanceTitle, setValue])

  useEffect(() => {
    if (formStepsGrouped && Object.keys(formStepsGrouped)?.length === 1) {
      const form = Object.keys(formStepsGrouped)[0]

      const formSteps = formStepsGrouped[form]

      setSearchParams({
        context: assistanceId,
        form: formId || "",
        steps: formSteps[0]?.groups.map((row) => row?.id).join(","),
        category: assistanceCategory || "",
      })
    }
  }, [formSteps, formStepsGrouped])

  const handleChangeGeoLocation = (e) => {
    setGeolocation(e?.target?.value)
  }

  return (
    <AssistancePlanContextScreen
      {...{
        loadingTechnical,
        formQuestionMessage,
        farmerDetails,
        assistanceTitle,
        assistanceLoadingTitle,
        assistanceId,
        assistanceDate,
        setAssistanceDate,
        onlyForm,
        modalAddFormIsOpen,
        setModalAddFormIsOpen,
        handleSaveDraft: () => handleSave("draft"),
        handleOpenLinkMessage: handleOpenMessagesField,
        handleCloseFormModal,
        handleAddSteps,
        handleChangeChecked,
        handleActiveIndicator,
        stepsToRespond,
        indicatorTabsOptions,
        formSteps,
        checkedSteps,
        handleChange,
        values: answers,
        handleSave: (hasEvaluation, sendEvaluation) =>
          defaultAnswers && defaultAnswers.length
            ? handleUpdate(hasEvaluation, sendEvaluation)
            : handleSave("save", sendEvaluation),
        hasAllAnswers,
        contextData: contextData.length
          ? contextData
          : fixedMessage.length
            ? [{ messageIds: fixedMessage }]
            : {},
        defaultAnswers,
        contextDetails,
        evaluationModal,
        formId,
        onChangeFile,
        uploadedFiles,
        uploaded,
        removeFile,
        loadingProcessImage,
        removePinnedMessage,
        modalReturnIsOpen,
        setModalReturnIsOpen,
        handleCloseReturnModal,
        handleConfirmReturn,
        currentStep,
        sendEvaluationMessage,
        setSendEvaluationMessage,
        goToNextStep,
        goToPreviousStep,
        evaluationValue,
        handleChangeEvaluationValue,
        handleChangeScheduleReturn,
        loading,
        loadingSendEvaluation,
        assistanceCategory,
        technicalList,
        isUserAdmin,
        isUserManager,
        currentUser: user?.id,
        dataToUpdate,
        handleChangeDataToUpload,
        loadLocation,
        getNewLoc: getUserLocation,
        handleChangeSelectedProject,
        selectedProject,
        handleRemoveScheduledAssistance,
        removeEvaluationStep,
        projectOptions,
        assistanceTitleEdit,
        handleAssistanceTitleEdit,
        register,
        getValues,
        watch,
        loadingSteps: loadingSteps,
        origin: search?.split("&origin=")[1],
        category: search?.split("category=")[1]?.split("&")[0],
        handleChangeGeoLocation,
        geolocation,
        handleRemoveEvidence
      }}
    />
  )
}
